import React from "react";
import { motion } from "framer-motion";

export default function FaceValueAccess() {
  return (
    <section style={{ background: "#121212" }}>
      {/* Full-width image — edge to edge, no rounding */}
      <motion.div
        initial={{ opacity: 0 }}
        whileInView={{ opacity: 1 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <img
          src="/images/giveaway/shutterstock_2764775985.jpg"
          alt="גישה לאירועים"
          className="w-full"
          style={{ display: "block" }}
        />
      </motion.div>

      <div className="max-w-3xl mx-auto px-6 text-center py-20 md:py-28">
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2
            className="font-bold text-white mb-8"
            style={{ fontSize: "clamp(1.75rem, 3vw, 3rem)" }}
          >
            Face Value Access
          </h2>

          <p className="text-base md:text-lg leading-relaxed mb-6" style={{ color: "#FFFFFF" }}>
            MOM3NTUM משנה את חוקי המשחק.
          </p>

          <p className="text-base md:text-lg leading-relaxed mb-6" style={{ color: "#FFFFFF" }}>
            במקום לרדוף אחרי כרטיסים ולקוות לטוב,
            <br />
            <span className="font-bold">אתם מבטיחים לעצמכם זכות גישה מראש.</span>
          </p>

          <p className="text-base md:text-lg leading-relaxed mb-6" style={{ color: "#FFFFFF" }}>
            הנוסחה שלנו פשוטה:
            <br />
            טכנולוגיה מתקדמת + קהילה חזקה = הזדמנות
            מובטחת לרכוש כרטיס במחיר המקורי שלו.
          </p>

          <p className="text-lg font-bold" style={{ color: "#D7FF37" }}>
            בלי פרמיות, בלי קומבינות ובלי &quot;דמי טיפול&quot;
            <br />
            דמיוניים.
          </p>
        </motion.div>
      </div>

      {/* Lime separator */}
      <div className="max-w-3xl mx-auto px-6">
        <div style={{ height: "2px", background: "#D7FF37" }} />
      </div>
    </section>
  );
}
